export const setUser = (user = '') => {
    localStorage.setItem('authusuario', JSON.stringify(user));    
}

export const getUser = () => {
    return JSON.parse(localStorage.getItem('authusuario'));
}

export const removeUser = () => {
    localStorage.removeItem('authusuario');
}